import { hydrateStorage } from "@/lib/storage";

type CapacitorGlobal = { isNativePlatform?: () => boolean };

const isNative = (): boolean => {
  if (typeof window === "undefined") return false;
  const cap = (window as unknown as { Capacitor?: CapacitorGlobal }).Capacitor;
  return cap?.isNativePlatform?.() === true;
};

let booted = false;

export async function initNative(
  onBackButton?: (canGoBack: boolean) => boolean | void,
): Promise<void> {
  if (booted) return;
  booted = true;

  await hydrateStorage();

  if (!isNative()) return;

  document.documentElement.classList.add("capacitor-native");

  try {
    const [{ StatusBar, Style }, { SplashScreen }, { App }] = await Promise.all([
      import("@capacitor/status-bar"),
      import("@capacitor/splash-screen"),
      import("@capacitor/app"),
    ]);

    // Hide splash immediately — launchAutoHide is a fallback but this gives us control.
    SplashScreen.hide({ fadeOutDuration: 250 }).catch(() => {});

    StatusBar.setStyle({ style: Style.Dark }).catch(() => {});
    StatusBar.setBackgroundColor({ color: "#0a0a0a" }).catch(() => {});
    // Do NOT call setOverlaysWebView here — MainActivity.java handles edge-to-edge
    // display with manual WindowInsetsCompat padding on the WebView parent. Calling
    // setOverlaysWebView({ overlay: false }) would invoke setDecorFitsSystemWindows(true)
    // which undoes the native inset handling → content overlaps the status bar.

    App.addListener("backButton", ({ canGoBack }) => {
      const handled = onBackButton?.(canGoBack);
      if (handled === true) return;
      if (canGoBack || window.history.length > 1) {
        window.history.back();
      } else {
        App.exitApp();
      }
    });
  } catch (err) {
    console.error("[native bootstrap] failed", err);
  }
}
